import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'

import { withSearch } from '@elastic/react-search-ui'
import { SearchContextState } from '@elastic/react-search-ui/lib/cjs/withSearch'
import { FormattedMessage } from 'react-intl'

import { Grid, Theme, useMediaQuery } from '@mui/material'

import RefineResultsIcon from 'app/assets/icons/homePage/refine-results.svg'
import LogoIcon from 'app/assets/icons/logo.svg'
import Button from 'app/components/base/Button'
import SearchBox from 'app/features/SearchFeature/components/SearchBox'
import useModal from 'app/hooks/useModal'

const FilterDialog = dynamic(() => import('./FilterDialog'), {
  ssr: false
})

type ButtonFindProps = {
  hideModal: () => void
}

type DependentFilterContext = Pick<
  SearchContextState,
  'filters' | 'sortField' | 'searchTerm'
>

const FilterPanelMobile = () => {
  const { open: isOpenModal, showModal, hideModal } = useModal()
  const [isModalPreloaded, setIsModalPreloaded] = useState<boolean>(false)

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  useEffect(() => {
    if (!isMobile) return

    const timeOut = setTimeout(() => setIsModalPreloaded(true), 500)

    return () => clearTimeout(timeOut)
  }, [isMobile])

  return (
    <>
      <Grid
        spacing={1.5}
        container
        sx={{ display: { xs: 'flex', md: 'none' } }}
      >
        <Grid item xs={6}>
          <SearchBox />
        </Grid>

        <Grid item xs={6}>
          <ButtonFind hideModal={showModal} />
        </Grid>
      </Grid>

      {isModalPreloaded && (
        <FilterDialog title="Filters" open={isOpenModal} onClose={hideModal} />
      )}
    </>
  )
}

const ButtonFind = withSearch<ButtonFindProps, DependentFilterContext>(
  ({ filters, sortField, searchTerm }) => ({ filters, sortField, searchTerm })
)(({ filters, hideModal, sortField }) => {
  const [hasFilters, setHasFilters] = useState(false)

  useEffect(() => {
    const hasElasticFilters = !!filters.length || !!sortField

    if (hasFilters === hasElasticFilters) return

    setHasFilters(hasElasticFilters)
  }, [filters, sortField])

  return (
    <Button
      sx={{ p: 0, px: 1.5 }}
      size="large"
      onClick={hideModal}
      startIcon={hasFilters ? <RefineResultsIcon /> : <LogoIcon />}
    >
      {hasFilters ? (
        <FormattedMessage defaultMessage="Refine Results" />
      ) : (
        <FormattedMessage defaultMessage="Find My Part" />
      )}
    </Button>
  )
})

export default FilterPanelMobile
